import {
  HeadingGroup,
  ModalLayout,
  Pagination,
  SearchFilters,
  Table,
} from "@wac-ui-dashboard/wac_component_library";
import React from "react";
import { FaSort } from "react-icons/fa";
import OrderColumn from "../../Global/OrderColumn";
import useTransactiontype from "./useTransactiontype";
import EmptyData from "../../Global/EmptyData";

const TransactionType = () => {
  const {
    isLoading,
    isFetching,
    transactionTypeList,
    // tableFields,
    transactionTypeState,
    showEditModal,
    paginationOptions,
    handleEditColumnsClick,
    updateTransactionTypeFields,
    handlePagination,
    handleClearClick,
    handlePageSize,
    handleSearch,
    handleSort,
    refetch,
    getRow,
  } = useTransactiontype();
  return (
    <>
      <HeadingGroup title="Transaction Types" className={`pro-mb-4`} />
      <div className="col-auto pro-pt-3 pro-pb-6">
        <SearchFilters
          onSearchInput={handleSearch}
          loading={isLoading}
          SearchIcon={
            <span className="material-symbols-outlined"> search </span>
          }
          showClearFilters={transactionTypeState?.search === "" ? false : true}
          handleClear={handleClearClick}
          searchInputProps={{ value: transactionTypeState?.search }}
          handleActionClick={handleEditColumnsClick}
        />
        {transactionTypeList?.data?.result?.length === 0 ? (
          <EmptyData />
        ) : (
          <Table
            multiSelect={false}
            data={transactionTypeList?.data?.result || []}
            uniqueID={"id"}
            fields={transactionTypeList?.data?.fields || []}
            SortIcon={<FaSort />}
            editIcon={<span className="material-symbols-outlined">edit</span>}
            handleSort={handleSort}
            getRow={getRow}
            loading={isFetching}
            clear={transactionTypeState?.clearSelection}
            perpage={transactionTypeState?.currentPageSize}
            assignable={false}
            deletable={false}
            editable={false}
            showCheckBox={false}
          />
        )}

        {transactionTypeList?.data?.result?.length > 0 && (
          <Pagination
            currentPage={transactionTypeState?.currentPage}
            totalPageCount={Math.ceil(
              transactionTypeList?.data.total_count /
                transactionTypeState?.currentPageSize
            )}
            defaultValue={paginationOptions?.filter(
              (item) => item?.value === transactionTypeState?.currentPageSize
            )}
            onPageChange={handlePagination}
            options={paginationOptions}
            onActionChange={handlePageSize}
            center
          />
        )}
        <ModalLayout
          show={showEditModal}
          handleClose={handleEditColumnsClick}
          backdrop="static"
        >
          <div className="pro-m-5">
            <OrderColumn
              title={"Choose which columns you see"}
              refetchData={refetch}
              tableFields={transactionTypeList?.data?.fields || []}
              moduleId={transactionTypeList?.data?.module_id}
              updateData={updateTransactionTypeFields}
            />
          </div>
        </ModalLayout>
      </div>
    </>
  );
};

export default TransactionType;
